import { render, staticRenderFns } from "./payRule.vue?vue&type=template&id=420182d1&scoped=true"
import script from "./payRule.vue?vue&type=script&lang=js"
export * from "./payRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420182d1",
  null
  
)

export default component.exports